import styled from "styled-components";
import { Drawer } from 'antd';
import { defaultTheme } from "@nxsys/constants/defaultConfig";

export const StyledDrawer = styled(Drawer)`
  width: 560px;
  .ant-drawer-header {
    .ant-drawer-header-title {
      color: ${defaultTheme.theme.palette.text.primary};

      .ant-drawer-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 22px;
        line-height: 34px;
      }
    }
    .ant-drawer-extra {
      .ant-btn-icon svg {
        font-size: 12px;
      }
    }
  }

  .ant-drawer-footer {
    display: flex;
    justify-content: flex-end;
  }
`;
